import { render } from "./footer.vue?vue&type=template&id=deeebc62&scoped=true"
import script from "./footer.vue?vue&type=script&lang=ts"
export * from "./footer.vue?vue&type=script&lang=ts"

import "./footer.vue?vue&type=style&index=0&id=deeebc62&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-deeebc62"

export default script